import React, { Component } from 'react';
import { IndexLink } from 'react-router';

import _ from "i18n";

export default class Home extends Component {

  render () {
    return (
      <li>
        <IndexLink to="/" activeClassName="active" className="menu__link">{_('home')}</IndexLink>
      </li>
    );
  }
};



// WEBPACK FOOTER //
// ./app/components/menu/Home.js